
import Vue from "vue";
import { pageIndex } from "@/modules/support/api";
import { LanguageTypeEnum } from "@/modules/support/enums";
import { PageIndexResource } from "@/modules/support/types";
import i18n from "@/plugins/i18n";

interface ComponentData {
  isLoading: boolean;
  pages: PageIndexResource[];
}

export default Vue.extend({
  name: "InformationView",
  data: (): ComponentData => ({
    isLoading: false,
    pages: [],
  }),
  mounted() {
    this.fetchPages();
  },
  methods: {
    navigateToDetails(page: PageIndexResource) {
      this.$router.push({
        name: "information.details",
        params: {
          pageSlug: page.slug as unknown as string,
        },
      });
    },
    async fetchPages() {
      const locale = i18n.locale as keyof typeof LanguageTypeEnum;
      if (this.isLoading || !(locale in LanguageTypeEnum)) return;
      this.isLoading = true;
      try {
        const response = await pageIndex(LanguageTypeEnum[locale]);
        this.pages = response.data.data;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        throw error;
      }
    },
  },
});
